<mat-form-field class="input" appearance="fill" (click)="touched = true">
  <mat-label class="mb-xs" *ngIf="label" [ngClass]="{ asterix: required }">{{ label }}</mat-label>
  <input
    matInput
    [type]="typeInput"
    [disabled]="disabled"
    [(ngModel)]="value"
    (ngModelChange)="ngModelChange.emit($event); onChange(value)"
    (change)="onChange(value)"
    (click)="handleClick($event); onTouched()"
    (paste)="onPaste($event)"
    (drop)="onDrop($event)"
    [errorStateMatcher]="matcher"
    [placeholder]="placeholder"
    [mask]="mask"
    [appDataTestid]="ngControl.name"
  />
  <mat-icon
    color="accent"
    class="pointer"
    *ngIf="typeInput === 'password'"
    (click)="changeVision()"
    [ngClass]="{ grayIcon: !value }"
    matSuffix
  >
    visibility
  </mat-icon>
  <mat-icon
    color="accent"
    class="pointer"
    *ngIf="typeInput === 'text'"
    (click)="changeVision()"
    [ngClass]="{ grayIcon: !value }"
    matSuffix
  >
    visibility_off
  </mat-icon>
  <mat-error>
    <app-errors-label
      [label]="label"
      *ngIf="touched && ngControl.errors"
      [errors]="ngControl.errors"
    ></app-errors-label>
  </mat-error>
</mat-form-field>
